import { Input as ChakraInput, useFieldContext } from "@chakra-ui/react";
import { useThemeConfig } from "../../hooks/useThemeConfig";
import { forwardRef } from "react";

export const Input = forwardRef(
  /**
   * @param {import("@chakra-ui/react").InputProps} props
   */
  function Input(props, ref) {
    const { inputProps } = useThemeConfig();

    const field = useFieldContext();

    return (
      <ChakraInput
        ref={ref}
        {...{
          ...inputProps,
          borderColor: field?.invalid ? undefined : inputProps.borderColor,
        }}
        {...props}
      />
    );
  },
);
